import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../environments/environment';
import { Collection, Manufacturer } from '../app/models/catalog';

/**
 * The global manufacturer (brand) list that catalog materials point at. Tenants may add brands of
 * their own in the web app; those are not listed here.
 */
@Injectable({
  providedIn: 'root'
})
export class ManufacturerService {
  private readonly manufacturersUrl = `${environment.api.baseUrl}${environment.api.endpoints.manufacturers}`;

  constructor(private http: HttpClient) {}

  getManufacturers(): Observable<Collection<Manufacturer>> {
    return this.http.get<Collection<Manufacturer>>(this.manufacturersUrl);
  }

  create(name: string): Observable<Manufacturer> {
    return this.http.post<Manufacturer>(this.manufacturersUrl, { name });
  }

  rename(id: number, name: string): Observable<Manufacturer> {
    return this.http.put<Manufacturer>(`${this.manufacturersUrl}/${id}`, { name });
  }
}
